<template>
  <div id="pdfPool"></div>
</template>

<script lang="ts" setup>
import Pdfh5 from 'pdfh5'
import 'pdfh5/css/pdfh5.css'

const props = defineProps({
  url: {
    type: String,
    default: '',
  },
})

watchEffect(
  () => {
    new Pdfh5('#pdfPool', {
      pdfurl: props.url,
      backTop: true,
      lazy: true,
    })
  },
  {
    flush: 'post',
  },
)
</script>
<style lang="less">
#pdfPool .loadEffect {
  margin-top: 0;
  display: none !important;
}
#pdfPool.pdfjs,
#pdfPool.pdfjs .viewerContainer {
  height: auto;
}
.pinch-zoom-container {
  height: auto !important;
}
</style>
